import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Layout from '../../components/Layout';
import AuthUser from '../../components/AuthUser';

import userIcon from '../../assets/img/user-icon-resize.webp';
import notFoundImg from '../../assets/img/404-module-not-found-2.webp';

// SVG LOGOS
import brokenImg from '../../assets/img/broken-image-general.png';
import belmenySvg from '../../assets/img/logos/BELMENY-SVG.svg'
import ingcoSvg from '../../assets/img/logos/INGCO-SVG.svg'
import vertSvg from '../../assets/img/logos/VERT-SVG.svg'
import quilosaSvg from '../../assets/img/logos/QUILOSA-SVG.svg'
import fleximaticSvg from '../../assets/img/logos/FLEXIMATIC-SVG.svg'
import imouSvg from '../../assets/img/logos/IMOU-SVG.svg'
import { Modal } from 'react-bootstrap';
import { RiCloseCircleFill } from 'react-icons/ri';
import { getZonasSupervisor, getEstimaciones, getTotalFPC, getCobranzasSupervisor2 } from '../../api/requestSupervisor';

import Chart from "react-apexcharts";

import { startOfMonth, endOfMonth, addMonths, endOfDay, startOfWeek, endOfWeek, subWeeks, format, set } from 'date-fns';
import moment from 'moment/moment';
import { GiBreakingChain } from 'react-icons/gi';
import { CobranzasGerencia2 } from '../../components/modulos_gerente/CobranzasGerencia2';

export const Estimaciones = () => {

  useEffect(() => {
    loadZonasSupervisor()
    handleMonthLoader('1mes')
  }, []);

  // State del usuario
  const { user, getToken } = AuthUser();
  const navigate = useNavigate();

  // State del loading
  const [loading, setLoading] = useState(true);

  // State de datos
  const [username, setUsername] = useState('')
  const [loadingText, setLoadingText] = useState('estadisticas...');
  const [whichMonthLoad, setWhichMonthLoad] = useState('1mes');
  const [zonaSelected, setZonaSelected] = useState('Ningúna...');
  const [mesSelected, setMesSelected] = useState('Ningúno...');
  const [totalMeta, setTotalMeta] = useState(0);
  const [montoProductos, setMontoProductos] = useState(0);
  const [montoFacturado, setMontoFacturado] = useState(0);
  const [montoCancelado, setMontoCancelado] = useState(0);
  const [montoPendiente, setMontoPendiente] = useState(0);
  const [facturadoPorcentaje, setFacturadoPorcentaje] = useState(0);
  const [canceladoPorcentaje, setCanceladoPorcentaje] = useState(0);
  const [pendientePorcentaje, setPendientePorcentaje] = useState(0);
  const [multipleTops, setMultipleTops] = useState(false);
  const [estimacionGenerada, setEstimacionGenerada] = useState(false);
  const [montoEstimaciones, setMontoEstimaciones] = useState([]);
  const [zonasSupervisor, setZonasSupervisor] = useState([]);
  const [ventasProductos, setVentasProductos] = useState([]);
  const [chartEstimaciones, setChartEstimaciones] = useState({});
  // const [barEstiVend, setBarEstiVend] = useState({});
  const [barChartVentas, setBarChartVentas] = useState({})
  const [topDataMetas, setTopDataMetas] = useState({});
  const [topDataMetas2, setTopDataMetas2] = useState({});
  const [topDataMetas3, setTopDataMetas3] = useState({});

  // States del modal
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const [modalLoading, setModalLoading] = useState("");


  // Nombres de los meses
  const [threeMonthsName, setThreeMonthsName] = useState(startOfMonth(addMonths(new Date(), -3)).toLocaleString("es-MX", { month: "long" }));
  const [twoMonthsName, setTwoMonthsName] = useState(startOfMonth(addMonths(new Date(), -2)).toLocaleString("es-MX", { month: "long" }));
  const [oneMonthName, setOneMonthName] = useState(startOfMonth(addMonths(new Date(), -1)).toLocaleString("es-MX", { month: "long" }));

  //Fecha inicio y fin de los meses
  const [start3Months, setStart3Months] = useState(new Date(startOfMonth(addMonths(new Date(), -3))).toISOString().slice(0, 10))
  const [end3Months, setEnd3Months] = useState(format(new Date(endOfDay(endOfMonth(addMonths(new Date(), -3))).toISOString().slice(0, 10)), 'yyyy-MM-dd 23:59:59'))
  const [start2Months, setStart2Months] = useState(new Date(startOfMonth(addMonths(new Date(), -2))).toISOString().slice(0, 10))
  const [end2Months, setEnd2Months] = useState(format(new Date(endOfDay(endOfMonth(addMonths(new Date(), -2))).toISOString().slice(0, 10)), 'yyyy-MM-dd 23:59:59'))
  const [start1Month, setStart1Month] = useState(new Date(startOfMonth(addMonths(new Date(), -1))).toISOString().slice(0, 10))
  const [end1Month, setEnd1Month] = useState(format(new Date(endOfDay(endOfMonth(addMonths(new Date(), -1))).toISOString().slice(0, 10)), 'yyyy-MM-dd 23:59:59'));
  const [startActualMonth, setStartActualMonth] = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd HH:mm:ss'))
  const [endActualMonth, setEndActualMonth] = useState(format(endOfMonth(new Date()), 'yyyy-MM-dd HH:mm:ss'))
  const [mesSelected2, setMesSelected2] = useState('');
  const [añoSelected, setAñoSelected] = useState(2025);
  // Dentro de DashboardGerente, junto a los demás useState:
  const [supervisorsList, setSupervisorsList] = useState([]);            // Lista de códigos de supervisor únicos
  const [selectedSupervisor, setSelectedSupervisor] = useState('');      // Supervisor actualmente seleccionado
  const [resultCobranzasAll2025, setResultCobranzasAll2025] = useState([]); // Datos crudos 2025
  const [resultCobranzasAll2024, setResultCobranzasAll2024] = useState([]); // Datos crudos 2024
  // Mapeo código → nombre de supervisor
  const supervisorNamesMap = {
    S01: "Lissete Núñez",
    S02: "Luis Sastre",
    S03: "Javier Villasmil",
    S04: "Adel Codallo",
    S05: "ARELYS Colmenares",
    S06: "Antonio García Pérez",
    S07: "Carlos Valiente",
    // si agregas S08, S09, etc. basta con extender este objeto
  };

  const handleButtonClick = (buttonId) => {
    setShow(true);
    switch (buttonId) {
      case 'CobranzasGerencia2':
        setModalTitle("Cobranzas de gerencia")
        setModalBody("CobranzasGerencia2")
        setModalLoading("sus cobranzas")
        break;
      default:
        setModalTitle("Resumen de pedidos por día")
        setModalBody("pedidosPorDia")
        setModalLoading("resumen de pedidos por día")
        break;
    }
  };

  function calcularRangoFechas(mesNombre, año) {
    // date-fns: parsea e.g. "Julio 2025" → Date
    const fecha = parse(`${mesNombre} ${año}`, 'MMMM yyyy', new Date());
    const inicio = startOfMonth(fecha);
    const fin = endOfMonth(fecha);
    return {
      fechaInicio: format(inicio, 'yyyy-MM-dd HH:mm:ss'),
      fechaFin: format(fin, 'yyyy-MM-dd HH:mm:ss')
    };
  }

  function sortByMonth(arr) {
    var months = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
    arr.sort(function (a, b) {
      return months.indexOf(a.mes)
        - months.indexOf(b.mes);
    });
  }

  const handleImageError = (event) => {
    event.target.src = brokenImg;
  };

  const handleMonthLoader = (opt) => {
    switch (opt) {
      case '1mes':
        setWhichMonthLoad('1mes')
        // loadHistorico1erMes()
        break;

      case '2mes':
        setWhichMonthLoad('2mes')
        // loadHistorico2doMes()
        break;

      case '3mes':
        setWhichMonthLoad('3mes')
        // loadHistorico3erMes()
        break;

      default:
        // loadHistorico1erMes()
        break;
    }
  }

  const loadZonasSupervisor = async () => {
    setLoading(true)
    setLoadingText(`datos iniciales`)
    const [resZonasSup] = await Promise.all([getZonasSupervisor(user.CodGerente)])
    setZonasSupervisor(await resZonasSup);

    const allCobranzas2025 = await getCobranzasSupervisor2(2025) || [];
    const allCobranzas2024 = await getCobranzasSupervisor2(2024) || [];

    // Verifica en consola que realmente sean arrays
    //console.log("allCobranzas2025:", allCobranzas2025);
    //console.log("allCobranzas2024:", allCobranzas2024);

    const sup2025 = Array.isArray(allCobranzas2025) ? allCobranzas2025.map(r => r.Supervisor) : [];
    const sup2024 = Array.isArray(allCobranzas2024) ? allCobranzas2024.map(r => r.Supervisor) : [];

    const uniques = Array.from(new Set([...sup2025, ...sup2024]));
    //console.log("supervisores únicos", uniques);

    setSupervisorsList(uniques);
    setSelectedSupervisor(uniques[0] || '');

    setResultCobranzasAll2025(allCobranzas2025)

    setResultCobranzasAll2024(allCobranzas2024)
    //  console.log('setResultCobranzasAll2025 cargado con:', allCobranzas2025);
    //console.log('setResultCobranzasAll2025 cargado con:', allCobranzas2024);
    setLoading(false)
  }

  const generateEstimaciones = async (zonaSeleccionada, mesSeleccionado) => {
    let resEstimaciones;
    let fpc;
    setLoading(true)
    setLoadingText(`estimaciones de ${mesSeleccionado} para la zona ${zonaSeleccionada}...`)

    if (mesSeleccionado === threeMonthsName) {
      resEstimaciones = await getEstimaciones(zonaSeleccionada, start3Months + ' 00:00:00', end3Months)
      fpc = await getTotalFPC(start3Months + ' 00:00:00', end3Months)
    } else if (mesSeleccionado === twoMonthsName) {
      resEstimaciones = await getEstimaciones(zonaSeleccionada, start2Months + ' 00:00:00', end2Months)
      fpc = await getTotalFPC(start2Months + ' 00:00:00', end2Months)
    } else if (mesSeleccionado === oneMonthName) {
      resEstimaciones = await getEstimaciones(zonaSeleccionada, start1Month + ' 00:00:00', end1Month)
      fpc = await getTotalFPC(start1Month + ' 00:00:00', end1Month)
    } else {
      resEstimaciones = await getEstimaciones(zonaSeleccionada, start1Month + ' 00:00:00', end1Month)
      fpc = await getTotalFPC(start1Month + ' 00:00:00', end1Month)
    }

    if (resEstimaciones.length > 0) {
      setEstimacionGenerada(true)
      setMontoEstimaciones(resEstimaciones)
      setMontoFacturado(fpc.Facturado)
      setMontoCancelado(fpc.CanceladoMasAbonado)
      setMontoPendiente(fpc.Pendiente)
      setChartEstimaciones({
        options: {
          labels: resEstimaciones.map((Vendedor) => `${Vendedor.Nombre}`),
          legend: {
            show: true,
            position: "bottom",
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
              width: '50px',
              stacked: true,
              stackType: "100%",

            }
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#000']
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#fff']
          },
          colors: ['#3268a9', '#96bc47', '#d94440'],
        },
        series: [{
          name: 'Facturado',
          data: resEstimaciones.map((Vendedor) => `${((Vendedor.Facturado / fpc.Facturado) * 100).toFixed(2)}%`)
        }, {
          name: 'Cancelado',
          data: resEstimaciones.map((Vendedor) => `${((Vendedor.CanceladoMasAbonado / fpc.Facturado) * 100).toFixed(2)}%`)
        }, {
          name: 'Pendiente',
          data: resEstimaciones.map((Vendedor) => `${((Vendedor.Pendiente / fpc.Facturado) * 100).toFixed(2)}%`)
        }]
      })
      let facturadoSum = 0
      let canceladoSum = 0
      let pendienteSum = 0

      for (let i = 0; i < resEstimaciones.length; i++) {
        facturadoSum += ((resEstimaciones[i].Facturado * 100) / fpc.Facturado)
        canceladoSum += ((resEstimaciones[i].CanceladoMasAbonado * 100) / fpc.Facturado)
        pendienteSum += ((resEstimaciones[i].Pendiente * 100) / fpc.Facturado)
      }
      setFacturadoPorcentaje(facturadoSum)
      setCanceladoPorcentaje(canceladoSum)
      setPendientePorcentaje(pendienteSum)
      setLoading(false)
    } else {
      setEstimacionGenerada(false)
      setLoading(false)
    }
  }


  const meses2025 = Array.isArray(resultCobranzasAll2025)
    ? resultCobranzasAll2025
      .filter(r => r.Supervisor === selectedSupervisor)
      .sort((a, b) => a.MesNum - b.MesNum)
    : [];

  const meses2024 = Array.isArray(resultCobranzasAll2024)
    ? resultCobranzasAll2024
      .filter(r => r.Supervisor === selectedSupervisor)
      .sort((a, b) => a.MesNum - b.MesNum)
    : [];

  // Dentro de tu componente Estimaciones (o DashboardGerente)
  const getPieOptions = (item) => ({
    chart: {
      events: {
        dataPointSelection: (_e, _chart, { dataPointIndex }) => {
          // cuando el usuario haga clic en cualquier "slice"
          setMesSelected(item.Mes);
          setAñoSelected(2025);  // o dinámico si quieres
          handleButtonClick('CobranzasGerencia2');
        }
      }
    },
    labels: [
      `${((item.Pagado * 100) / (item.Pagado + item.Pendiente)).toFixed(2)}% Pagado`,
      `${((item.Pendiente * 100) / (item.Pagado + item.Pendiente)).toFixed(2)}% Pendiente`
    ],
    legend: { show: true, position: "bottom" },
    plotOptions: {
      pie: {
        dataLabels: { enabled: true }
      }
    },
    colors: ['#27ae60b3', '#ff0000b3']
  });


  const getPieOptions2 = (item) => ({
    chart: {
      events: {
        dataPointSelection: (_e, _chart, { dataPointIndex }) => {
          // cuando el usuario haga clic en cualquier "slice"
          setMesSelected(item.Mes);
          setAñoSelected(2024);  // o dinámico si quieres
          handleButtonClick('CobranzasGerencia2');
        }
      }
    },
    labels: [
      `${((item.Pagado * 100) / (item.Pagado + item.Pendiente)).toFixed(2)}% Pagado`,
      `${((item.Pendiente * 100) / (item.Pagado + item.Pendiente)).toFixed(2)}% Pendiente`
    ],
    legend: { show: true, position: "bottom" },
    plotOptions: {
      pie: {
        dataLabels: { enabled: true }
      }
    },
    colors: ['#27ae60b3', '#ff0000b3']
  });

  return (
    <>
      <Layout>
        <div className="container-fluid mt-5">
          {
            (loading) ?
              <>
                <div className="text-center">
                  <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div className="loader-book">
                      <div>
                        <ul>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                        </ul>
                      </div>
                      <span>Cargando {loadingText}</span>
                    </div>
                  </div>
                </div>
              </> :
              <>

                {/* Div para movil */}
                <div className="text-center d-sm-block d-md-none">
                  {/* <img width={80} src={belmenyLogo} alt="Logo Belmeny Group" className='text-center mt-3 drop-shadow' /> */}
                  <br />
                  <img src={notFoundImg} className="mx-auto w-100" alt="No se ha podido cargar la imagen..." />
                </div>

                {/* Div para web */}
                <div className='d-none d-md-block'>
                  <div className="container-fluid rounded">
                    <div className="row">
                      <div className="col">
                        <div className="text-belmeny">
                          <h2 className='fs-1'><strong>Bienvenido</strong></h2>
                          <h3>{user.Nombre}</h3>
                          <h5><i>{username}</i></h5>
                        </div>
                      </div>
                      <div className="col">
                        <img src={userIcon} alt="Logo Belmeny Group" className='float-end me-5 drop-shadow-sm' />
                      </div>
                    </div>

                    <div className="dashboard-title mt-2 mb-3">
                      <h4 className='bg-belmeny text-light px-5 rounded-pill'>Estimaciones Cobranzas</h4>
                    </div>

                    {/* COBRANZAS POR VENDEDOR */}
                    <div className="mb-5 bg-white rounded drop-shadow-card p-3">
                      <h4 className="text-center text-belmeny fst-italic mb-1">
                        Cobranzas de su gerencia
                      </h4>
                      <h6 className="text-muted fst-italic fw-normal text-center">
                        Las gráficas serán mostradas dependiendo si el mes tiene una deuda pendiente.
                      </h6>

                      {/* ▼ Dropdown de supervisores ▼ */}
                      <div className="mb-3 d-flex align-items-center">
                        <label htmlFor="selectSupervisor" className="me-2 fw-semibold">
                          Supervisor:
                        </label>
                        <select
                          id="selSupervisor"
                          className="form-select"
                          value={selectedSupervisor}
                          onChange={e => setSelectedSupervisor(e.target.value)}
                        >
                          {supervisorsList.map(code => (
                            <option key={code} value={code}>
                              {supervisorNamesMap[code] || code}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="accordion mt-2" id="accordionCobranzas">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingLastYear">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLastYear" aria-expanded="true" aria-controls="collapseLastYear">
                              <h5 className="text-belmeny fst-italic text-center mt-2">Año 2025</h5>
                            </button>
                          </h2>
                          <div
                            id="collapseLastYear"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingLastYear"
                            data-bs-parent="#accordionCobranzas"
                          >
                            <div className="accordion-body">
                              {/*
                              Por cada supervisor (en tu caso realmente solo el seleccionado),
                              filtras sus meses y aplicas el mismo layout 4xN
                            */}
                              {supervisorsList
                                .filter(sup => sup === selectedSupervisor)        // o quita el filter si quieres todos
                                .map(sup => {
                                  const filas = []; // aquí coleccionamos cada "row" de 4 meses
                                  // 1) filtramos y ordenamos los meses de 2025 para este sup

                                  // 2) creamos el array de filas
                                  for (let i = 0; i < meses2025.length; i += 4) {
                                    filas.push(meses2025.slice(i, i + 4));
                                  }

                                  return (
                                    <div key={sup} className="mb-4">
                                      <h6 className="fw-bold">Supervisor: </h6>

                                      {filas.map((grupo, rowIdx) => (
                                        <div key={rowIdx} className="row mb-2">
                                          {grupo.map((item, colIdx) => (
                                            <div key={colIdx} className="col">
                                              <h5 className="text-center text-belmeny text-capitalize">
                                                {item.Mes}
                                              </h5>
                                              <Chart
                                                options={getPieOptions(item)}
                                                series={[item.Pagado, item.Pendiente]}
                                                type="pie"
                                                width="350px"
                                                className="d-flex align-middle justify-content-center"
                                              />
                                              <button
                                                className="buttonMonths w-100 my-2"
                                                onClick={() => {
                                                  handleButtonClick('CobranzasGerencia2');
                                                  setMesSelected(item.Mes);
                                                  setAñoSelected(2025);
                                                }}
                                              >
                                                <span>Ver detalles de</span>{' '}
                                                <span className="text-capitalize">{item.Mes}</span>
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="heading2024">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2024" aria-expanded="false" aria-controls="collapse2024">
                              <h5 className="text-belmeny fst-italic text-center mt-2">Año 2024</h5>
                            </button>
                          </h2>
                          <div
                            id="collapse2024"
                            className="accordion-collapse collapse show"
                            aria-labelledby="heading2024"
                            data-bs-parent="#accordionCobranzas"
                          >
                            <div className="accordion-body">
                              {/* DEBUG CONSOLE */}
                              {console.log(
                                'meses2025 renderizados:',
                                resultCobranzasAll2024.filter(r => r.Supervisor === selectedSupervisor)
                              )
                              }
                              {/* Agrupamos en filas de 4 */}
                              {supervisorsList
                                .filter(sup => sup === selectedSupervisor)        // o quita el filter si quieres todos
                                .map(sup => {
                                  const filas = []; // aquí coleccionamos cada "row" de 4 meses
                                  // 1) filtramos y ordenamos los meses de 2025 para este sup

                                  // 2) creamos el array de filas
                                  for (let i = 0; i < meses2024.length; i += 4) {
                                    filas.push(meses2024.slice(i, i + 4));
                                  }

                                  return (
                                    <div key={sup} className="mb-4">
                                      <h6 className="fw-bold">Supervisor: </h6>

                                      {filas.map((grupo, rowIdx) => (
                                        <div key={rowIdx} className="row mb-2">
                                          {grupo.map((item, colIdx) => (
                                            <div key={colIdx} className="col">
                                              <h5 className="text-center text-belmeny text-capitalize">
                                                {item.Mes}
                                              </h5>
                                              <Chart
                                                options={getPieOptions2(item)}
                                                series={[item.Pagado, item.Pendiente]}
                                                type="pie"
                                                width="350px"
                                                className="d-flex align-middle justify-content-center"
                                              />
                                              <button
                                                className="buttonMonths w-100 my-2"
                                                onClick={() => {
                                                  handleButtonClick('CobranzasGerencia2');
                                                  setMesSelected(item.Mes);
                                                  setAñoSelected(2024);
                                                }}
                                              >
                                                <span>Ver detalles de</span>{' '}
                                                <span className="text-capitalize">{item.Mes}</span>
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-5 mb-3">
                      <h5 className="text-belmeny fst-italic">Seleccione una zona:</h5>
                    </div>
                    <div className="row">
                      <div className="row">
                        {
                          zonasSupervisor.map((zona) =>
                            <div className='col'>
                              <button className='buttonMonths w-100' onClick={(e) => setZonaSelected(zona.Sector)}><span>{zona.Sector}</span></button>
                            </div>
                          )
                        }
                      </div>
                    </div>

                    <div className="mt-4 mb-3">
                      <h5 className="text-belmeny fst-italic">Seleccione un mes:</h5>
                    </div>
                    <div className="row mb-4">
                      <div className="col-1 me-3">
                        <button className='buttonMonths' onClick={(e) => setMesSelected(threeMonthsName)}><span className="text-capitalize">{threeMonthsName}</span></button>
                      </div>
                      <div className="col-1 mx-3">
                        <button className='buttonMonths' onClick={(e) => setMesSelected(twoMonthsName)}><span className="text-capitalize">{twoMonthsName}</span></button>
                      </div>
                      <div className="col-1 ms-3">
                        <button className='buttonMonths' onClick={(e) => setMesSelected(oneMonthName)}><span className="text-capitalize">{oneMonthName}</span></button>
                      </div>
                    </div>

                    <div className="row mt-4 mb-3">
                      <div className="col-3">
                        <div className="row">
                          <div className="col">
                            <h5 className="text-belmeny">Zona Seleccionada: {zonaSelected}</h5>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col">
                            <h5 className="text-belmeny">Mes Seleccionado: <span className="text-capitalize">{mesSelected}</span></h5>
                          </div>
                        </div>
                      </div>
                    </div>

                    {
                      (zonaSelected !== 'Ningúna...' && mesSelected !== 'Ningúno...') ?
                        <div className="row mb-5">
                          <div className="col">
                            <div className='col'>
                              <button className='buttonMonths' onClick={(e) => generateEstimaciones(zonaSelected, mesSelected)}><span>Generar Estimaciones</span></button>
                            </div>
                          </div>
                        </div> : null
                    }

                    {/* Chart de ventas x marca */}
                    {
                      (estimacionGenerada) ?
                        <>
                          <div className="row">
                            <div className="col">
                              <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
                                <h4 className="text-belmeny text-center mx-auto fst-italic">Estimaciones del mes: <span className="text-capitalize">{mesSelected}</span> <br /> Zona: {zonaSelected}</h4>
                                <div className="row my-3">
                                  <div className="col"></div>
                                  <div className="col-2"><h5 className="fw-bold text-belmeny">Facturado: <span style={{ color: '#3268a9' }}>${montoFacturado}</span></h5></div>
                                  <div className="col-2"><h5 className="fw-bold text-belmeny">Pendiente: <span style={{ color: '#d94440' }}>${montoPendiente}</span></h5></div>
                                  <div className="col-2"><h5 className="fw-bold text-belmeny">Cancelado: <span style={{ color: '#96bc47' }}>${montoCancelado}</span></h5></div>
                                  <div className="col"></div>
                                </div>
                                <div className="container-fluid mx-auto row bg-lighten mt-3 py-3">
                                  <div className="col-2">
                                    <h5 className="text-uppercase text-belmeny">VENDEDOR</h5>
                                  </div>
                                  <div className="col">
                                    <h5 className="text-uppercase text-belmeny text-center">TOTAL FACTURADO</h5>
                                  </div>
                                  <div className="col">
                                    <h5 className="text-uppercase text-belmeny text-center">TOTAL FAC/NE PENDIENTES</h5>
                                  </div>
                                  <div className="col">
                                    <h5 className="text-uppercase text-belmeny text-center">TOTAL FAC/NE CANCELADAS</h5>
                                  </div>
                                </div>
                                {
                                  montoEstimaciones.map((Vendedor) =>
                                    <div className="row mt-3 container-fluid mx-auto pb-4 fw-bold">
                                      <div className="col-2 text-belmeny">{Vendedor.CodVendedor} - {Vendedor.Nombre}</div>
                                      <div className="col text-center" style={{ color: '#3268a9' }}>
                                        ${Vendedor.Facturado} - {((Vendedor.Facturado / montoFacturado) * 100).toFixed(2)}%
                                      </div>
                                      <div className="col text-center" style={{ color: '#d94440' }}>
                                        ${Vendedor.Pendiente} - {((Vendedor.Pendiente / montoFacturado) * 100).toFixed(2)}%
                                      </div>
                                      <div className="col text-center" style={{ color: '#96bc47' }}>
                                        ${Vendedor.CanceladoMasAbonado} - {((Vendedor.CanceladoMasAbonado / montoFacturado) * 100).toFixed(2)}%
                                      </div>
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="division my-5"></div>
                          <div className="row">
                            <div className="col">
                              <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
                                <h4 className="text-belmeny text-center mx-auto fst-italic">Estimaciones del mes: <span className="text-capitalize">{mesSelected}</span> <br /> Zona: {zonaSelected}</h4>

                                <div className='row'>
                                  <div className="col">
                                    <Chart
                                      options={chartEstimaciones.options}
                                      series={chartEstimaciones.series}
                                      type="bar"
                                      width="100%"
                                      height="500px"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="division my-5"></div>

                          <div className="row">
                            <div className="col">
                              <div className="m-auto p-3 drop-shadow-card rounded" style={{ background: '#3268a9' }}>
                                <h4 className="text-center text-white">Facturado</h4>
                                <h5 className="text-center text-white">{facturadoPorcentaje.toFixed(2)}%</h5>
                              </div>
                            </div>
                            <div className="col">
                              <div className="m-auto p-3 drop-shadow-card rounded" style={{ background: '#d94440' }}>
                                <h4 className="text-center text-white">FAC/NE Pendiente</h4>
                                <h5 className="text-center text-white">{pendientePorcentaje.toFixed(2)}%</h5>
                              </div>
                            </div>
                            <div className="col">
                              <div className="m-auto p-3 drop-shadow-card rounded" style={{ background: '#96bc47' }}>
                                <h4 className="text-center text-white">FAC/NE Cancelado</h4>
                                <h5 className="text-center text-white">{canceladoPorcentaje.toFixed(2)}%</h5>
                              </div>
                            </div>
                          </div>
                        </>
                        :
                        <div className="row">
                          <div className="col">
                            <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
                              <h4 className="text-belmeny text-center mx-auto fst-italic">Debe escoger un mes y zona para generar el reporte de estimaciones...</h4>
                            </div>
                          </div>
                        </div>
                    }

                    <div className="division my-5"></div>



                  </div>
                </div>
              </>
          }
        </div>
      </Layout >
      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header className='bg-belmeny text-light'>
          <Modal.Title className='fst-italic'>{modalTitle}</Modal.Title>
          <RiCloseCircleFill
            className='text-danger fs-1 modal-close bg-light rounded-circle'
            onClick={() => setShow(false)}
          />
        </Modal.Header>

        <Modal.Body>
          {/* Si modalBody es 'cobranzasGerencia', mostramos solo ese componente */}
          {/* ... dentro del Modal.Body en Estimaciones.jsx */}
{modalBody === 'CobranzasGerencia2' && (
  <div className="p-4">
    <h5 className="text-belmeny text-center mb-3">
      Cobranzas de {mesSelected} {añoSelected}
    </h5>
    {/* PASAMOS selectedSupervisor aquí */}
    <CobranzasGerencia2 mes={mesSelected} año={añoSelected} supervisor={selectedSupervisor} />
  </div>
)}

        </Modal.Body>
      </Modal>

    </>
  )
}
